define(function (require, exports, module) {
    'use strict';

    var _ = require('Cloud/Application/_');
    var features = require('Cloud/Application/Features');
    var TestFile = require('./TestFile');
    var backendResponseTextOfPost = require('./backendResponseTextOfPost');
    var uploadLog = require('../../uploadLog');
    var UploadReason = require('../../UploadReason');
    var ConnectionFail = require('../../fails/ConnectionFail');
    var HttpError = require('../../errors/HttpError');
    var WrongResultError = require('../../errors/WrongResultError');

    /**
     * @namespace
     */
    var backendDispatcher = {
        /**
         * В миллисекундах.
         * @type {number}
         */
        PING_TIMEOUT: features.getFeatureParam('newUpload', 'pingTimeout', 3000),

        /**
         * @type {TestFile}
         */
        _testFile: null,

        /**
         * @returns {Promise}
         * @resolves {TestFile}
         * @rejects {Error}
         */
        createTestFile: function () {
            return new Promise(function (resolve) {
                var testFile = new TestFile();

                resolve(testFile);
            });
        },

        /**
         * @returns {Promise}
         * @resolves {TestFile}
         * @rejects {Error}
         */
        getTestFile: function () {
            var testFile = backendDispatcher._testFile;
            var promise;

            if (testFile) {
                promise = Promise.resolve(testFile);
            } else {
                promise = backendDispatcher.createTestFile();
                promise = promise.then(function (testFile) {
                    backendDispatcher._testFile = testFile;

                    return testFile;
                });
            }

            return promise;
        },

        /**
         * @param {TestFile} testFile
         * @param {string} uploadServerUrl
         * @returns {Promise}
         * @resolves {Event}
         * @rejects {Event|Error}
         */
        uploadTestFile: function (testFile, uploadServerUrl) {
            var promise = new Promise(function (resolve) {
                var xhr = new XMLHttpRequest();

                xhr.open('POST', uploadServerUrl); // TODO: use PUT (feature param)
                xhr.withCredentials = true;
                xhr.timeout = backendDispatcher.PING_TIMEOUT;

                var listener = function listener() {
                    xhr.removeEventListener('load', listener);
                    xhr.removeEventListener('error', listener);
                    xhr.removeEventListener('timeout', listener);

                    var xhrData = {
                        status: xhr.status,
                        responseText: xhr.responseText,
                    };

                    resolve(xhrData);
                };

                xhr.addEventListener('load', listener);
                xhr.addEventListener('error', listener);
                xhr.addEventListener('timeout', listener);

                xhr.send(testFile.formData); // TODO: use testFile.blob for PUT
            });

            return promise;
        },

        /**
         * @param {string} uploadServerPingUrl
         * @returns {Promise}
         * @resolves {Event}
         * @rejects {Event|Error}
         */
        _makeNginxTestRequest: function (uploadServerPingUrl) {
            var promise = new Promise(function (resolve) {
                var xhr = new XMLHttpRequest();

                xhr.open('GET', uploadServerPingUrl); // TODO: use PUT (feature param)
                xhr.withCredentials = true;
                xhr.timeout = backendDispatcher.PING_TIMEOUT;

                var listener = function listener() {
                    xhr.removeEventListener('load', listener);
                    xhr.removeEventListener('error', listener);
                    xhr.removeEventListener('timeout', listener);

                    var xhrData = {
                        status: xhr.status,
                        responseText: xhr.responseText,
                    };

                    resolve(xhrData);
                };

                xhr.addEventListener('load', listener);
                xhr.addEventListener('error', listener);
                xhr.addEventListener('timeout', listener);

                xhr.send();
            });

            return promise;
        },

        /**
         * @param {string} uploadServerUrl
         * @param {UploadDescriptor} descriptor
         * @returns {Promise}
         * @resolves {Event}
         * @rejects {UploadReason|Error}
         */
        pingNginx: function (uploadServerUrl, descriptor) {
            var promise = backendDispatcher.getPingUrl(uploadServerUrl);
            var nginxUrl;

            promise = promise.then(function (url) {
                nginxUrl = url;
                return backendDispatcher._makeNginxTestRequest(url);
            });

            promise = promise.then(function (xhrData) {
                var HTTP_OK = 200;
                var BODY_OK = 'OK';
                var status = xhrData.status;
                var responseText = xhrData.responseText;
                var source = UploadReason.SOURCE_BACKEND;
                var stack;
                var reason;
                var promise;

                if (status === HTTP_OK) {
                    var data;

                    try {
                        data = JSON.parse(responseText);
                    } catch (e) {
                        try {
                            // TODO: отрезать, если будем трогать ручку пинга
                            data = new Function('return ' + responseText)();
                        } catch (e) {
                            data = {};
                        }
                    }

                    if (data.body === BODY_OK && data.status === HTTP_OK) {
                        promise = Promise.resolve();
                    } else {
                        stack = new Error('WrongResultError');
                        reason = new WrongResultError(stack, source, responseText);

                        promise = Promise.reject(reason);
                    }
                } else if (status) {
                    stack = new Error('HttpError');
                    reason = new HttpError(stack, source, status, responseText);

                    promise = Promise.reject(reason);
                } else {
                    stack = new Error('ConnectionFail');
                    reason = new ConnectionFail(stack, source);

                    promise = Promise.reject(reason);
                }

                promise = promise.catch(function (reason) {
                    reason.setId(descriptor.get('id'));
                    reason.setMeta('upload-nginx-url', nginxUrl.split('?')[0]);
                    uploadLog.customizedReason(reason, 'ping-nginx');

                    return Promise.reject(reason);
                });

                return promise;
            });

            return promise;
        },

        /**
         * @param {string} uploadServerUrl
         * @param {UploadDescriptor} descriptor
         * @returns {Promise}
         * @resolves {string} uploadServerUrl
         * @rejects {UploadReason|Error}
         */
        ping: function (uploadServerUrl, descriptor) {
            var promise = backendDispatcher.getTestFile();

            promise = promise.then(function (testFile) {
                var promise = backendDispatcher.uploadTestFile(testFile, uploadServerUrl);

                return promise;
            });

            promise = promise.then(function (xhrData) {
                var HTTP_OK = 200;
                var HTTP_CREATED = 201;
                var status = xhrData.status;
                var responseText = xhrData.responseText;
                var source = UploadReason.SOURCE_BACKEND;
                var stack;
                var reason;
                var promise;

                if (status === HTTP_OK || status === HTTP_CREATED) {
                    var data = backendResponseTextOfPost.parse(responseText);

                    // Для POST сервер отвечает HTTP 200 и присылает текст ошибки,
                    // например: -EC349C1F081BB8A80C682FD69098093CAF6C8726;2097152;illegal
                    reason = data.error;

                    if (reason) {
                        promise = Promise.reject(reason);
                    } else if (data.hash === TestFile.HASH && data.size === TestFile.SIZE) {
                        promise = Promise.resolve(uploadServerUrl);
                    } else {
                        stack = new Error('WrongResultError');
                        reason = new WrongResultError(stack, source, responseText);

                        promise = Promise.reject(reason);
                    }
                } else if (status) {
                    // Для status 400 responseText может содержать сообщения:
                    // no content type, unsupported content type, empty body,
                    // no content length, too long boundary и т.д.
                    stack = new Error('HttpError');
                    reason = new HttpError(stack, source, status, responseText);

                    promise = Promise.reject(reason);
                } else {
                    stack = new Error('ConnectionFail');
                    reason = new ConnectionFail(stack, source);

                    promise = Promise.reject(reason);
                }

                promise = promise.catch(function (reason) {
                    reason.setId(descriptor.get('id'));
                    reason.setMeta('upload-url', uploadServerUrl.split('?')[0]);
                    uploadLog.customizedReason(reason, 'ping');

                    return Promise.reject(reason);
                });

                return promise;
            });

            return promise;
        },

        /**
         * @returns {Promise}
         * @resolves {string}
         * @rejects {Error}
         */
        getUploadUrl: function () {
            var url = _.urls.upload();
            var promise = Promise.resolve(url);

            return promise;
        },

        /**
         * @returns {Promise}
         * @resolves {string}
         * @rejects {Error}
         */
        updateUploadUrl: function (cache) {
            var promise = Promise.resolve();

            promise = promise.then(function () {
                var promise;

                if (!cache) {
                    promise = _.makeDispatcherUpdate().catch(function () {
                        return Promise.resolve();
                    });
                } else {
                    promise = Promise.resolve();
                }

                return promise;
            });

            promise = promise.then(function () {
                return backendDispatcher.getUploadUrl();
            });

            return promise;
        },

        /**
         * @returns {Promise}
         * @resolves {string}
         * @rejects {Error}
         */
        getPingUrl: function (uploadUrl) {
            // не бейте :)
            var url = uploadUrl.split('?')[0].split('/').splice(0, 3).join('/') + '/ping/';
            var promise = Promise.resolve(url);

            return promise;
        },
    };

    module.exports = backendDispatcher;
});
